import helper from './helper.js'

export default {

    ToIconClass: function (str) {
        if (str == undefined || str == null || str == "" || str.length == 0) return "";

        let s = helper.ToKebabCase(str);

        return `icon ${s}`;
    }

}